import { PageBlockDefinitionAppearance } from "./aux";
import { z } from "zod";
//
// Enums
//
export const PageBlockDefinitionLayoutType = z.enum(["Column", "Row"]);
export const PageBlockDefinitionLayoutGap = z.enum([
    "Small",
    "Medium",
    "Large",
    "None",
]);
export const PageBlockDefinitionLayoutAlign = z.enum(["Start", "Center", "End"]);
export const PageBlockDefinitionLayoutResizing = z.enum(["Fill", "Hug"]);
//
// Definitions
//
export const PageBlockDefinitionLayoutBase = z.object({
    type: PageBlockDefinitionLayoutType,
    gap: PageBlockDefinitionLayoutGap.optional(),
    columnAlign: PageBlockDefinitionLayoutAlign.optional(),
    columnResizing: PageBlockDefinitionLayoutResizing.optional(),
});
export const PageBlockDefinitionLayout = PageBlockDefinitionLayoutBase.extend({
    children: z.lazy(() => z.array(PageBlockDefinitionLayout.or(z.string()))),
});
export const PageBlockDefinitionVariant = z.object({
    id: z.string(),
    name: z.string(),
    image: z.string().optional(),
    description: z.string().optional(),
    documentationLink: z.string().optional(),
    layout: PageBlockDefinitionLayout,
    maxColumns: z.number().optional(),
    defaultColumns: z.number().optional(),
    appearance: PageBlockDefinitionAppearance.optional(),
});
